<form name="pinCodeForm" *ngIf="pinCodeForm" [formGroup]="pinCodeForm">
  <div formArrayName="pinCode" class="pin-seguridad">
    <mat-form-field
      appearance="outline"
      *ngFor="let digit of pinCodeForm.controls.pinCode.controls; index as i"
      [ngClass]="changeBackgroud(i)"
      [ngClass]="{
        'pin-code-input': !applyPinCodeInputClass,
        'bold-text': applyPinCodeInputClass,
      }"
    >
      <input
        numbersOnly
        id="{{ i }}"
        type="number"
        [formControlName]="i"
        matInput
        (keydown)="processPin($event, i)"
        (keyup)="verifyPin()"
        pattern="\d"
      />
    </mat-form-field>
  </div>
</form>
